import React, {forwardRef} from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number,
  color?: string
}

export const CircleLoader = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24, ...rest }: IconProps, ref) => {
  return <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <g transform="translate(2 2)" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><circle opacity=".25" cx="10" cy="10" r="10"/><path d="M10 0a10 10 0 00-7.65 16.44"/></g>
    </svg>;
});
CircleLoader.displayName = 'CircleLoader';


